import { getFullUrl } from 'hubspot-url-utils';
import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
export const ALL_REFERRERS = [
// Breeze Studio
{
  getLinkText: () => I18n.text('marketplaceStorefront.referrerLinkText.breeze'),
  getReferrerUrl: () => `${getFullUrl('app')}/breeze-studio/${PortalIdParser.get()}`,
  productType: 'AGENT',
  referrer: 'breeze'
},
// Breeze Studio - Intro
{
  getLinkText: () => I18n.text('marketplaceStorefront.referrerLinkText.breeze'),
  getReferrerUrl: () => `${getFullUrl('app')}/breeze-studio/${PortalIdParser.get()}/manage-agents/intro`,
  productType: 'AGENT',
  referrer: 'breeze-intro'
},
// Breeze Studio - Agents
{
  getLinkText: () => I18n.text('marketplaceStorefront.referrerLinkText.breeze'),
  getReferrerUrl: () => `${getFullUrl('app')}/breeze-studio/${PortalIdParser.get()}/manage-agents/agents`,
  productType: 'AGENT',
  referrer: 'breeze-agents'
},
// Breeze Studio - Assistants
{
  getLinkText: () => I18n.text('marketplaceStorefront.referrerLinkText.breeze'),
  getReferrerUrl: () => `${getFullUrl('app')}/breeze-studio/${PortalIdParser.get()}/manage-agents/assistants`,
  productType: 'AGENT',
  referrer: 'breeze-assistants'
}];